import { FeatureFlag } from '@sonar-software/sonar-core';
import { JiraIcon } from '@ui/icons';
import React from 'react';
import { SonarMenuItem } from '@ui/menu';
import { ViewAreaSidebar } from '@ui/general';

import { CloudOutlined, KeyOutlined, SlackOutlined, SyncOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';

const menuItems: Array<SonarMenuItem> = [
	{
		icon: <UserOutlined />,
		key: FULL_ROUTES.SETTINGS_USER,
		label: COPY_SPECIFIC.USER
	},
	{
		icon: <TeamOutlined />,
		key: FULL_ROUTES.SETTINGS_TEAM,
		label: COPY_SPECIFIC.TEAM
	},
	{
		icon: <CloudOutlined />,
		key: FULL_ROUTES.SETTINGS_ORGANIZATION,
		label: COPY_SPECIFIC.SALESFORCE_ORGS
	},
	{
		icon: <SlackOutlined />,
		key: FULL_ROUTES.SETTINGS_SLACK,
		label: COPY_SPECIFIC.SLACK
	},
	{
		feature: FeatureFlag.JiraIntegration,
		icon: <JiraIcon />,
		key: FULL_ROUTES.SETTINGS_JIRA,
		label: COPY_SPECIFIC.JIRA
	},
	{
		icon: <SyncOutlined />,
		id: 'sync-menu-item',
		key: FULL_ROUTES.SYNC,
		label: COPY_SPECIFIC.METADATA_IMPORT,
		route: FULL_ROUTES.SYNC
	},
	{
		feature: FeatureFlag.OpenApiKeyManagement,
		icon: <KeyOutlined />,
		key: FULL_ROUTES.SETTINGS_DATA_DICTIONARY_API_KEYS,
		label: COPY_SPECIFIC.API_KEYS
	}
];

export const SettingsSidebar: React.FC = () => <ViewAreaSidebar
	id='settings-sidebar'
	items={ menuItems } />;
